import { 
    sBanner, 
    sBannerStep, 
    sShowScreen, 
    sInputKeyValidationHelper, 
    sAppendSafeLink 
} from '../../shared.min.js';


const cnfsd_hcc = (function () {

    const widget = document.getElementById('cnfsd-home-contents-calculator'),
        screens = widget.querySelectorAll('.widget__screen'),
        inputs = widget.querySelectorAll('input[type="text"]'),
        cumulativeValue = widget.querySelectorAll('.total-box .value'),
        continueButton = widget.querySelector('#home-contents__continue'),
        backButton = widget.querySelector('#home-contents__back'),
        restartButton = widget.querySelector('#home-contents__restart'),
        widgetFooter = widget.querySelector('.widget__screen-footer');


    let currentScreen = 1,
        sum = 0,
        valid = true;


    function init() {
        calculateTotal();
        handleInputs();
        setupButtonEvents();
    }

    sBanner(
        widget,
        [
            'Living room contents', 
            'Kitchen contents', 
            'Dining room contents', 
            'Bedroom(s) contents', 
            'Bathroom, garage and other contents', 
            'Shed and garden contents',
            'Results'
        ]
    );

    const screenNumber = () => {
        
        screens.forEach((screen, index) => {
            if (!screen.classList.contains('display-none')) {
                currentScreen = index + 1;
            }        
        });
        return currentScreen;
    };

    const setupButtonEvents = () => {
        continueButton.addEventListener('click', function () {
            if (formValid() === false) {
                return;
            }

            if (currentScreen < screens.length) {

                sShowScreen(screens, screenNumber() + 1);
                
                scrollTo({
                    top: (widget.offsetTop - 100),
                    behavior: 'smooth'
                });

                const currentForm = screens[currentScreen];
                if (currentForm) {
                    const firstInput = currentForm.querySelectorAll('input[type="text"]');
                    if (firstInput.length > 0) {
                        firstInput[0].focus();
                    }
                }

            }
            currentScreen = screenNumber();
            showElements();

        });

        backButton.addEventListener('click', function () {
            if (formValid() === false) {
                return;
            }

            if (currentScreen > 0 ) {
                sShowScreen(screens, screenNumber() - 1);
            } 

            currentScreen = screenNumber();

            showElements();

        });

        restartButton.addEventListener('click', function () {
            restartWidget();
            showElements();
        });

    };

    const formValid = () => {
        let formIsValid = true;
        const currentForm = screens[currentScreen - 1];
        const errorInputs = currentForm.querySelectorAll('.field-group--error');
        if (errorInputs.length > 0) {
            formIsValid = false;
            
            console.log(errorInputs[0]);

            scrollTo({
                top: errorInputs[0].offsetTop - 100,
                behavior: 'smooth'
            });
        }
        return formIsValid;
    }


    const handleInputs = () => {

        inputs.forEach((input) => {
            const fieldgroup = input.closest('.field-group');
            sInputKeyValidationHelper(input, 'numeric', fieldgroup);
            input.addEventListener('blur', function () {

                if (fieldValid(input, fieldgroup)) {
                    calculateTotal();
                }
            });
        });
    };

    //VALIDATION FUNCTION - RETURNS TRUE IF ALL INPUTS ARE VALID
    const fieldValid = (input, fieldgroup) => {
        valid = true;
       
        const trimmed = input.value.trim();
      
        fieldgroup.classList.remove('field-group--error');
        input.value = trimmed;

        if (isNaN(input.value) || input.value < 0) {
            fieldgroup.classList.add('field-group--error');
            valid = false;
        }

        return valid;
    };

    const calculateTotal = () => {
        sum = 0;

        inputs.forEach((input) => {
            const numericValue = parseFloat(input.value);
            if (!Number.isNaN(numericValue) && numericValue >= 0) {
                sum += numericValue;
            }
        });

        cumulativeValue.forEach((valueElement) => {
            valueElement.textContent = sum;
        });
    };

    const restartWidget = () => {
        inputs.forEach((input) => {
            input.value = "";
        });
        calculateTotal();
        sBannerStep(1);
        sShowScreen(screens, 1);
        currentScreen = screenNumber();
    };

    const showElements = () => {
        if (currentScreen === screens.length) {
            widgetFooter.classList.add('display-none');
        }
        if (currentScreen > 1) {
            backButton.classList.remove('display-none');
        }
        if (currentScreen === 1) {
            backButton.classList.add('display-none');
        }

        if (currentScreen < screens.length - 1) {
            widgetFooter.classList.remove('display-none');
        }
    
    };

    return {
		init: init,
	};
})();

document.addEventListener("DOMContentLoaded", function () {
	cnfsd_hcc.init();
});

